'use client';

import { Box, CirclePlay, Images, MapPin } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { LucideIcon } from '@/src/components/LucideIcon';
import * as styles from './photoGallery.styles';

type DesktopGalleryButtonsProps = {
  onAllPhotosClick: () => void;
  hasMultiplePhotos: boolean;
  has3dTour?: boolean;
  hasVideos?: boolean;
  hasStreetView?: boolean;
  on3dTourClick?: () => void;
  onVideosClick?: () => void;
  onStreetViewClick?: () => void;
};

export const DesktopGalleryButtons = ({
  onAllPhotosClick,
  hasMultiplePhotos,
  has3dTour,
  hasVideos,
  hasStreetView,
  on3dTourClick,
  onVideosClick,
  onStreetViewClick,
}: DesktopGalleryButtonsProps) => {
  const t = useTranslations('hdp');
  return (
    <div className={styles.desktopOverlayButtons}>
      {hasMultiplePhotos && (
        <button
          className={styles.overlayButton}
          onClick={onAllPhotosClick}
          aria-label={t('seeAllPhotos')}
          data-testid="hero-action-see-all-photos"
        >
          <LucideIcon icon={Images} size="sm" />
          {t('seeAllPhotos')}
        </button>
      )}
      {has3dTour && on3dTourClick && (
        <button
          className={styles.overlayButton}
          onClick={on3dTourClick}
          aria-label={t('view3dTours')}
          data-testid="hero-action-3d-tours"
        >
          <LucideIcon icon={Box} size="sm" />
          {t('threeDTours')}
        </button>
      )}
      {hasVideos && onVideosClick && (
        <button
          className={styles.overlayButton}
          onClick={onVideosClick}
          aria-label={t('viewVideos')}
          data-testid="hero-action-videos"
        >
          <LucideIcon icon={CirclePlay} size="sm" />
          {t('videos')}
        </button>
      )}
      {hasStreetView && onStreetViewClick && (
        <button
          className={styles.overlayButton}
          onClick={onStreetViewClick}
          aria-label={t('viewStreetView')}
          data-testid="hero-action-street-view"
        >
          <LucideIcon icon={MapPin} size="sm" />
          {t('streetView')}
        </button>
      )}
    </div>
  );
};
